import Flutterwave from 'flutterwave-vue-v3'
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

Vue.config.productionTip = false

Vue.use(Flutterwave, { publicKey: 'FLWPUBK-f4e496fc1643eebd42792c655017de6a-X' })

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
